import type { Meta, StoryObj } from "@storybook/react";

import { fakeGroupClassSeries } from "@/__mocks__/groupClassSeries";
import type { GroupClassSeriesPreviewCardProps } from "@/ui/components/groupClasses/series/preview/GroupClassSeriesPreviewCard";
import GroupClassSeriesPreviewCard from "@/ui/components/groupClasses/series/preview/GroupClassSeriesPreviewCard";
import { IllustrationName } from "@/ui/theme/icons/illustrations/groupClasses";

const example = fakeGroupClassSeries();

const StoryMeta: Meta<GroupClassSeriesPreviewCardProps> = {
  title: "Components/Group Classes/Series Preview Card",
  component: GroupClassSeriesPreviewCard,
  argTypes: {
    iconName: {
      control: "select",
      options: Object.values(IllustrationName),
    },
    isUserRegistered: { control: "boolean" },
    onSelect: { action: "selected" },
    recurrenceString: { control: "text" },
    timeRange: { control: "text" },
    title: { control: "text" },
  },
  args: {
    iconName: example.iconName.toLowerCase(),
    isUserRegistered: true,
    recurrenceString: "Every Monday",
    timeRange: "2 - 3pm",
    title: example.title,
  },
};

type Story = StoryObj<GroupClassSeriesPreviewCardProps>;

export const Primary: Story = {};
export default StoryMeta;
